module.exports = __webpack_public_path__ + "img/yyzxbg.946e76a.png";